module.exports = __webpack_public_path__ + "img/itrax.98cebe17.jpg";